import { Component, OnInit } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { ModalController } from "@ionic/angular";
import { InAppBrowser, InAppBrowserEvent, InAppBrowserOptions } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { ESignService } from "src/app/services/esign-service.service";
import { CasteValidityRefLetterApproverDetailModel } from "src/app/model/CasteValidityRefLetterApproverDetailModel";
import { CasteValRefLetterApproverService } from "src/app/services/caste-val-ref-letter-approver.service";
import { ViewPdfComponent } from "../view-pdf/view-pdf.component";

@Component({
  selector: "app-secure-caste-val-ref-letter-approver",
  templateUrl: "./caste-val-ref-letter-approver.component.html",
  styleUrls: ["./caste-val-ref-letter-approver.component.scss"],
})
export class CasteValRefLetterApproverComponent implements OnInit {
    isLoading: boolean = false;
    casteValRefLetterApproverDetail: CasteValidityRefLetterApproverDetailModel;
    submitDisabled: boolean;
    key: number;
    verificationStatus: string;
    
    constructor(private router: Router, private route: ActivatedRoute, 
        private casteValRefLetterApproverService: CasteValRefLetterApproverService, private iab: InAppBrowser,
        private esignService: ESignService,
        private modalCtrl: ModalController, private _snackBar: MatSnackBar) { }
    
    ngOnInit(): void { 
        this.submitDisabled = false;
        this.route.params.subscribe((params: Params) => {
            this.key = +params['key'];
            this.isLoading = true;
            this.casteValRefLetterApproverService.fetchCasteValRefLetterApproverDetail(this.key)
            .subscribe(data => {
                this.isLoading = false;
                if(data.status === 'SUCCESS') {
                    this.casteValRefLetterApproverDetail = data;
                }
                else {
                    this.casteValRefLetterApproverService.errorToast(data.errorMessage);
                }
            });
        });
    }
    
    onSubmit(verificationType: string) {

        if(verificationType === 'REJECTED'){
            if(confirm("Do you want to Reject Caste Validity Reference Letter Application?")){
            }else{
                return;
            }
        }

        this.isLoading = true;
        this.submitDisabled = true;
        this.casteValRefLetterApproverService.submitVerificationDetail(
            this.key, verificationType).subscribe(data => {
            
            if(data.status === 'SUCCESS') {
                if(verificationType === 'APPROVED') {
                    let url = data?.url;
                    let target = "";
                    let options: InAppBrowserOptions = {
                        zoom: "no",
                        hideurlbar: "yes",
                        toolbar: "no",
                        location: "no",
                        hidenavigationbuttons: "no",
                        usewkwebview: "yes",
                    };
                    if (localStorage.getItem("platform") == "ios") {
                        target = "_blank";
                    } else {
                        target = "_self";
                    }
            
                    const browser = this.iab.create(url, target, options);
                    browser.on("loadstart").subscribe((ev: InAppBrowserEvent) => {
                        console.log('onload stop--'+ev.url);
                        if (ev.url.startsWith("http://localhost:8100/secure/verify-esign/CASTE_VALIDITY_REF_LETTER")
                        || ev.url.startsWith("https://appdemo.mhada.gov.in/secure/verify-esign/CASTE_VALIDITY_REF_LETTER")
                        || ev.url.startsWith("https://ihlms.mhada.gov.in/secure/verify-esign/CASTE_VALIDITY_REF_LETTER")) {
                            this.isLoading = false;
                            browser.close();
                            this.isLoading = false;
                            this.router.navigate(['/secure', 'verify-esign', 'CASTE_VALIDITY_REF_LETTER', data?.esignKey], { replaceUrl: true });
                            window.location.reload();
                        }
                    });
                }else if(verificationType === 'REJECTED'){
                    this.ngOnInit();
                }
            }
            else {
                this.isLoading = false;
                this._snackBar.open(data.errorMessage, "Close", {
                    horizontalPosition: "right",
                    verticalPosition: "top",
                    panelClass: "warning-toast",
                    duration: 3 * 1000,
                });
                this.submitDisabled = false;
            }
        }, error => {
            this.submitDisabled = false;
            this.isLoading = false;
            this._snackBar.open(error.errorMessage, "Close", {
                horizontalPosition: "right",
                verticalPosition: "top",
                panelClass: "warning-toast",
                duration: 3 * 1000,
            });
        });        
    }

    async viewEsignCertificate() {
        this.casteValRefLetterApproverService.fetchEsignCertificate(this.key)
        .subscribe(async (data) => {
            if(data.status === 'SUCCESS') {
                this.downloadFile(data.data, this.casteValRefLetterApproverDetail?.applicationNo+"_CASTE_VALIDITY_REF_LETTER_"+new Date().getTime()+".pdf");
            }
            else {
                this.casteValRefLetterApproverService.errorToast(data.errorMessage);
            }
        });
    }

    downloadFile(base64:string | ArrayBuffer, fileName:string){
        const src = `data:application/pdf;base64,${base64}`;
        const link = document.createElement("a")
        link.href = src
        link.download = fileName
        link.click()
        
        link.remove()
    }

    async viewFile(fileType, file) {
        console.log(file);
        const modal = await this.modalCtrl.create({
            component: ViewPdfComponent,
                componentProps: {
                base64: file,
                documentName: fileType,
                fileName: fileType+"_"+this.casteValRefLetterApproverDetail?.applicationNo+"_"+new Date().getTime()+".pdf"
            }
        });
        modal.present();
    }
}